export const ABOUT_ITEMS = [
  {
    key: 1,
    title: 'Brief Description',
    pathname: '/about_us_pages/brief_desc',
  },
  {
    key: 2,
    title: 'Vision and Mission',
    pathname: '/about_us_pages/vision_mission',
  },
  {
    key: 3,
    title: 'Value',
    pathname: '/about_us_pages/value',
  },
];
export const CUSTOMER_CSV_REQUIRED_FIELD = ['amount', 'email'];

export const ORDER_STATUS_FILTER_LIST = [
  '',
  'waiting_payment',
  'payment_verified',
  'processed',
  'shipped',
  'delivered',
  'cancelled',
  'rejected',
  'failed',
  'completed',
];

export const WITHDRAWAL_STATUS_FILTER_LIST = [
  '',
  'pending',
  'success',
  'failed',
];

export const ACTIVE_INACTIVE_STATUS_FILTER_LIST = ['', 'active', 'inactive'];

export const DATE_FORMAT = 'DD/MM/YYYY';
